import { useRef } from "react";
import { ChevronRightIcon, ChevronLeftIcon } from "@heroicons/react/outline";

function Scroll({ children }) {
  const ref = useRef(null);

  const scroll = (scrollOffset) => {
    ref.current.scrollLeft += scrollOffset;
  };
  return (
    <div className="relative">
      <button
        onClick={() => scroll(-1000)}
        className="absolute top-1/3 -left-4 p-2 border rounded-full bg-white shadow-lg hover:shadow-xl z-30"
      >
        <ChevronLeftIcon className="h-5" />
      </button>
      <button
        onClick={() => scroll(1000)}
        className="absolute top-1/3 -right-4 p-2 border rounded-full bg-white shadow-lg hover:shadow-xl z-30"
      >
        <ChevronRightIcon className="h-5" />
      </button>
      <div
        className="flex space-x-4 overflow-contain overflow-x-auto scrollbar-hide"
        ref={ref}
      >
        {children}
      </div>
    </div>
  );
}

export default Scroll;
